<h2 mat-dialog-title i18n>Setup new two-factor authentication method</h2>
<mat-dialog-content>
  @switch (currentStep) {
    <!-- Step 1: Method Selection -->
    @case ('selectMethod') {
      <div>
        <p class="" i18n>Choose an authentication method:</p>
        <ul class="list-unstyled">
          @for (method of availableMethods; track method) {
            <li>
              <button class="btn btn-outline btn-lg btn-block" [class]="{'btn-primary': method.secure, 'btn-warning': !method.secure}" (click)="selectMethod(method.id)">
                {{ method.name }}
                @if (method.secure) { <span class="text-sm" i18n>(Recommended)</span> }
              </button>
            </li>
          }
        </ul>
      </div>
    }
    <!-- Step 2: Verification -->
    @case ('completeRegistration') {
      <div>
        @switch (selectedMethod) {
          <!-- Email OTP -->
          @case (MFAMethodsEnum.EMAIL_OTP) {
            <div>
              <p class="text-lg"><strong i18n>Configure email as your two-factor authentication method</strong></p>
              <form [formGroup]="otpForm">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label i18n>Enter code from your email</mat-label>
                  <input matInput formControlName="code" required />
                </mat-form-field>
              </form>
              <p>{{ errorMessage }}</p>
            </div>
          }
          <!-- TOTP -->
          @case (MFAMethodsEnum.TOTP) {
            <div>
              <p class="text-lg"><strong i18n>Configure your Authenticator App</strong></p>
              @if (qrCodeDataUrl) {
                <div>
                  <p i18n>Scan the QR code with your authenticator app:</p>
                  <img [src]="qrCodeDataUrl" alt="TOTP QR Code" i18n-alt />
                </div>
              }
              @if (secretKey) {
                <p class="box box-info flex justify-between items-center">
                  <span>{{ secretKey }}</span>
                  <button class="btn btn-sm btn-info" type="button" (click)="copyToClipboard()" i18n>Copy</button>
                </p>
              }
              <form [formGroup]="totpForm">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label i18n>Enter code from authenticator app</mat-label>
                  <input matInput formControlName="code" required />
                </mat-form-field>
              </form>
              @if (errorMessage.length > 0) {
                <p role="status" class="box box-danger">{{ errorMessage }}</p>
              }
            </div>
          }
        }
      </div>
    }
  }
</mat-dialog-content>

<!-- Footer Actions -->
<mat-dialog-actions align="end">
  <ul class="list-inline list-unstyled">
    <li>@if (currentStep === 'completeRegistration' && !isPreselectedMethod) {
      <button class="btn btn-info btn-outline" (click)="goBack()" i18n>Back</button>
    }</li>
    <li><button class="btn btn-warning btn-outline" mat-dialog-close (click)="closeDialog()" i18n>Cancel</button></li>
    <li>@if (currentStep === 'completeRegistration') {
      <button
        class="btn btn-primary"
        [disabled]="isCompleteRegistrationDisabled()"
        (click)="completeRegistration()"
        i18n>
        Verify and complete registration
      </button>
    }</li>
  </ul>
</mat-dialog-actions>
